import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutScoreCardControl extends Layout {
    carrierAccessorialPanel: Panel;
    checkboxExcludeCustomer: Checkbox;
    checkboxExcludeLocationCode: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeRevCode: Checkbox;
    customerAccessorialPanel: Panel;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelCarrierAccCharges: Label;
    labelCustomerAssessorialCharges: Label;
    labelExportFilters: Label;
    labelReasonCodes: Label;
    mainScoreCardPanel: Panel;
    reasonCodesPanel: Panel;
    scoreCardPanel: Panel;
    sourceCarrierScorecard: DataSource;
    sourceEdiPartnerCode: DataSource;
    sourceInterfaceCodes: DataSource;
    switchIsActive: Switch;
    tableReasonCodesMapping: Table;
    textboxAccountManager: Textbox;
    textboxCarrierDetention: Textbox;
    textboxCarrierFuelSurcharge: Textbox;
    textboxCarrierLayover: Textbox;
    textboxCarrierLoadUnload: Textbox;
    textboxCarrierLumper: Textbox;
    textboxCarrierOtherAccessorial: Textbox;
    textboxCarrierReconsignment: Textbox;
    textboxCarrierStopOff: Textbox;
    textboxCarrierTonu: Textbox;
    textboxCuFuelSurcharge: Textbox;
    textboxCustStopOff: Textbox;
    textboxCustomerDetention: Textbox;
    textboxCustomerIdList: Textbox;
    textboxCustomerLayover: Textbox;
    textboxCustomerLoadUnload: Textbox;
    textboxCustomerLumper: Textbox;
    textboxCustomerOtherAccessorial: Textbox;
    textboxCustomerReconsignment: Textbox;
    textboxCustomerTonu: Textbox;
    textboxExportLoadOption: Textbox;
    textboxFrequency: Textbox;
    textboxKpiScoreUpdatePreference: Textbox;
    textboxLocationFilter: Textbox;
    textboxOrderModeFilter: Textbox;
    textboxOrderType: Textbox;
    textboxPassword: Textbox;
    textboxReportingDate: Textbox;
    textboxRevenueCode: Textbox;
    textboxScoresLastUpdated: Textbox;
    textboxUrl: Textbox;
    textboxUserName: Textbox;
}
